import { RegisterSuccessPage } from "@/features/auth/pages/RegisterSuccess";
import { background } from "@/theme/colors";
import { Box } from "@mui/material";

const RegisterSuccess = () => {
  return (
    <Box width="100%" display="flex" minHeight="100vh" justifyContent="center" py={8} bgcolor={background.primary}>
      <RegisterSuccessPage />
    </Box>
  );
};

export default RegisterSuccess;
